module.exports = __webpack_public_path__ + "static/media/squareFigure.dc7dbde8.jpg";